/* eslint-disable
    no-console,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let BlConsole;
const _ = require('lodash');

const style = {
  success: {
    color: '#098B8C',
  },
  warn: {
    color: '#D2A764',
  },
  error: {
    color: '#D86353',
  },
};

const compiledStyle = _.mapValues(style, val => _.map(val, (v, k) => `${k}:${v}`).join(';'));

module.exports = angular
  .module('dev.console', [])

  .service(
    'blConsole',
    (BlConsole = class BlConsole {
      log(val, styleName) {
        return console.log(`%c${val}`, compiledStyle[styleName]);
      }
    }),
  );
